import { log } from "../../engine/logger/logger";
import { Actor } from "../actors/Actor";
import { gameData } from "../GameManager";
import { Item } from "../items/Item";

export const wield2hMsg = (actor: Actor) => {
  const weapon = actor.wielding.left || actor.wielding.right;
  log(
    actor === gameData.player
      ? `${actor.breed.logName} wield ${weapon?.breed.logName} in both hands`
      : `${actor.breed.logName} wields ${weapon?.breed.logName} in both hands`
  );
};

export const wield1hMsg = (actor: Actor) => {
  const rightWeapon = actor.wielding.right;
  const leftWeapon = actor.wielding.left;
  if (rightWeapon) {
    log(
      gameData.player
        ? `${actor.breed.logName} wield ${rightWeapon.breed.logName} with your right hand`
        : `${actor.breed.logName} wields ${rightWeapon.breed.logName} with their right hand`
    );
  }
  if (leftWeapon) {
    log(
      gameData.player
        ? `${actor.breed.logName} wield ${leftWeapon.breed.logName} with your left hand`
        : `${actor.breed.logName} wields ${leftWeapon.breed.logName} with their left hand`
    );
  }
};

export const wearArmorMsg = (actor: Actor) => {
  const armor = actor.wearing.armor;
  if (armor) {
    log(
      gameData.player
        ? `${actor.breed.logName} wear the ${armor.breed.logName}`
        : `${actor.breed.logName} wears the ${armor.breed.logName}`
    );
  }
};

export const takeOffMsg = (actor: Actor, item: Item) => {
  log(
    gameData.player
      ? `${actor.breed.logName} take off the ${item.breed.logName}`
      : `${actor.breed.logName} takes the ${item.breed.logName}`
  );
};

export const pickupMsg = (actor: Actor, item: Item) => {
  log(
    gameData.player
      ? `${actor.breed.logName} pick up the ${item.breed.logName}`
      : `${actor.breed.logName} picks up the ${item.breed.logName}`
  );
};

export const dropMsg = (actor: Actor, item: Item) => {
  log(
    gameData.player
      ? `${actor.breed.logName} drop up the ${item.breed.logName}`
      : `${actor.breed.logName} drops up the ${item.breed.logName}`
  );
};
